import React from "react";
import List from "@mui/material/List";
import SideBarDropdown from "./SideBarDropdown";
import { SideBarDropdownData } from "../../../constansts/LocalData";
import LoginIcon from "../../../assets/images/login-icon.png";
import SidebarFooterArt from "../../../assets/images/sidebar-footer-art.svg";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

const CommonSideBar = () => {
   const navigate = useNavigate();
   const location = useLocation();
   const role_id = useSelector((state) => state?.auth?.user?.data?.user?.role_id);
   const role_name = useSelector((state) => state?.auth?.user?.data?.user?.role_name);
   const user_name = useSelector(
      (state) =>
         state?.auth?.user?.data?.user?.name ||
         state?.auth?.user?.data?.user?.full_name ||
         "User Name"
   );
   const userInitials = user_name
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase())
      .join("");
   const isDashboardRoute = location.pathname === "/dashboard";

   return (
      <aside className="main-sidebar sidebar-dark-primary elevation-4 wis-sidebar">
         <Link to="/dashboard" className="brand-link wis-brand-link">
            <span className="wis-brand-icon-wrap">
               <img
                  src={LoginIcon}
                  alt="Web Idea Solution Icon"
                  className="brand-image wis-brand-logo"
               />
            </span>
            <span className="brand-text wis-brand-text">Web Idea Solution</span>
         </Link>
         <div className="sidebar wis-sidebar-scroll">
            <div className="user-panel mt-3 pb-3 mb-3 d-flex wis-user-panel">
               <div className="wis-user-avatar">{userInitials || "U"}</div>
               <div className="info wis-user-info">
                  <a href="#" className="d-block">
                     {user_name}
                     <br />
                     <span>{role_name}</span>
                  </a>
               </div>
            </div>

            <nav className="mt-2">
               <ul
                  className="nav nav-pills nav-sidebar flex-column wis-sidebar-menu"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
               >
                  <li className="nav-item menu-open">
                     <a
                        className={`nav-link wis-dashboard-link ${
                           isDashboardRoute ? "active" : ""
                        }`}
                        onClick={() => navigate("/dashboard")}
                     >
                        <i className="nav-icon fas fa-home" />
                        <p>Dashboard</p>
                     </a>
                  </li>

                  <List className="menu-open">
                     {SideBarDropdownData.filter((item) =>
                        item.roles.includes(role_id)
                     ).map((item, index) => {
                        const filteredDropdownList = item.dropdownList
                           ?.filter(dropdown => !dropdown.roles || dropdown.roles.includes(role_id))
                           .map(dropdown => ({
                              ...dropdown,
                              subDropdownList: dropdown.subDropdownList ? dropdown.subDropdownList.filter(sub => 
                                 !sub.roles || sub.roles.includes(role_id)
                              ) : []
                           }));
                        return (
                           <SideBarDropdown
                              label={item.menuName}
                              url={item.url}
                              icon={item.icon}
                              dropdownList={filteredDropdownList || []}
                              key={index.toString()}
                           />
                        );
                     })}
                  </List>
               </ul>
            </nav>
         </div>
         <div className="wis-sidebar-footer">
            <img src={SidebarFooterArt} alt="Sidebar footer art" className="wis-sidebar-footer-img" />
         </div>
      </aside>
   );
};

export default CommonSideBar;
